import { forwardRef, createElement } from 'react';

function IconAccountingYearCancel(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M4.5 16.25v3a.25.25 0 00.193.243l.057.007H13V21H4.75A1.75 1.75 0 013 19.25v-3h1.5zm4.946-6.103l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.718-1.72H3.75a.75.75 0 01-.102-1.493L3.75 13h6.44l-1.72-1.72a.75.75 0 01-.073-.976l.073-.084a.75.75 0 01.976-.073zM16.25 2a.75.75 0 01.75.75V3h2.25c.966 0 1.75.784 1.75 1.75V13h-1.5V8h-15v3.25H3v-6.5C3 3.784 3.784 3 4.75 3H7v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zM7 4.5H4.75a.25.25 0 00-.243.193L4.5 4.75V6.5h15V4.75a.25.25 0 00-.193-.243L19.25 4.5H17v.25a.75.75 0 11-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5zm12.804 10.147a.75.75 0 011.049 1.05l-.073.083-1.969 1.97 1.97 1.97a.75.75 0 01-.977 1.133l-.084-.073-1.97-1.969-1.97 1.97-.084.072a.75.75 0 01-1.049-1.05l.073-.083 1.969-1.97-1.97-1.97a.75.75 0 01.977-1.133l.084.073 1.97 1.969 1.97-1.97.084-.072z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var AccountingYearCancel = /*#__PURE__*/forwardRef(IconAccountingYearCancel);

export default AccountingYearCancel;
//# sourceMappingURL=AccountingYearCancel.js.map
